import {getLoanLibraryLoanStatusTextByValue} from "../../Loan/LoanLibrary/LoanManagement/loanLibraryLoanUtility";
import type {LoanLibraryPackingList} from "../packingList.types";

export const loanLibraryPackingListModel = ({

                                                shipAddressFormatted,
                                                dateCreatedFormatted,
                                                patron,
                                                loanLibraryCatalogItem,
                                                loanLibraryLoanStatus,
                                                shipDate="",
                                 }: Record<string, any> = {}): LoanLibraryPackingList => ({

    shipAddressFormatted,
    dateCreatedFormatted,
    patron,
    loanLibraryCatalogItem,
    loanLibraryLoanStatus,
    loanLibraryLoanStatusText: getLoanLibraryLoanStatusTextByValue(loanLibraryLoanStatus),
    shipDate,
});